<div class="row">
  <div class="col-sm-2"></div>
  <div class="col-sm-8">
    <div *ngFor="let item of survey">
      <div class="form-group">
        <label class="lblCls">
          {{item.questions}}
        </label>
        <br />
        <span *ngFor="let rating of item?.surveyRating; let indexOfelement=index;">
          <input type="radio" kendoRadioButton [value]="rating.id" [(ngModel)]="rating.checked" name="{{rating.name}}" (change)="onSelectionChange(item,rating)" /> {{rating.label}}
        </span>
      </div>
    </div>
    <div class="form-group">
      <label class="lblCls">
        Comments
      </label>
      <textarea kendoTextArea class="kendoInput"
                [(ngModel)]="comments"></textarea>
    </div>
    <div class="d-flex justify-content-center col-xs-12 col-sm-12">
      <button kendoButton primary="true" class="m-3"
              (click)="saveSurveyRatings()">
        Submit
      </button>
    </div>
  </div>
  <div class="col-sm-2"></div>
</div>


<section>
  <kendo-dialog *ngIf="surveyDialog.opened">
    <div style="text-align: center; margin: 30px;" >
      <span class="k-icon k-i-check-outline k-i-checkmark-outline k-i-success"
            style="font-size:50px;color:green"></span>
      <p>{{lblText.submitedInfo1?lblText.submitedInfo1:lblsurvey.submitedInfo1}}</p>
      <p>
        <button kendoButton primary="true" style="width: 300px;" [routerLink]="['/home']">{{lblText.continueShoppingLbl?lblText.continueShoppingLbl:lblsurvey.continueShoppingLbl}}</button>
      </p>
     
    </div>
  </kendo-dialog>
</section>
